module.exports = __webpack_public_path__ + "static/media/yoga.cd13e3d7.jpg";